import React, { useEffect, useRef, useState } from 'react';
import RendConf from './RendConf';

const GSI_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

// A Google Identity Services szkript betöltése (egyszer).
function loadGsiScript() {
    return new Promise(function(resolve, reject) {
        if (window.google && window.google.accounts && window.google.accounts.id) {
            resolve();
            return;
        }
        var meglevo = document.getElementById('gsi-script');
        if (meglevo) {
            meglevo.addEventListener('load', function() { resolve(); });
            meglevo.addEventListener('error', function() { reject(); });
            return;
        }
        var script = document.createElement('script');
        script.id = 'gsi-script';
        script.src = GSI_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.onload = function() { resolve(); };
        script.onerror = function() { reject(); };
        document.head.appendChild(script);
    });
}

// "Folytatás Google-fiókkal" gomb (lekerekített, középre igazított). A gomb a Google-tól kapott ID tokent
// (credential) adja át az onCredential-nek; a token érvényességét a SZERVER ellenőrzi.
// Ha nincs beállítva Google Client ID, a gomb nem jelenik meg.
export default function GoogleBelepes({onCredential}) {
    const gombRef = useRef(null);
    const callbackRef = useRef(onCredential);
    const [hiba, setHiba] = useState(false);
    callbackRef.current = onCredential;
    // A Client ID a szerverről érkezik, az oldal betöltése után; a gombot akkor kell betölteni, amikor megvan.
    const clientId = RendConf.google_login_client_id;

    useEffect(function() {
        if (!clientId) {
            return;
        }
        var megszunt = false;
        // ha néhány másodperc után sincs gomb (pl. böngésző-kiegészítő tiltja, vagy a Google nem engedi az eredetet), jelezzük
        var idozito = setTimeout(function() {
            if (!megszunt && gombRef.current && gombRef.current.childElementCount === 0) {
                setHiba(true);
            }
        }, 5000);
        loadGsiScript().then(function() {
            if (megszunt || !gombRef.current) {
                return;
            }
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: function(resp) { callbackRef.current(resp.credential); },
                ux_mode: 'popup'
            });
            window.google.accounts.id.renderButton(gombRef.current, {
                theme: 'outline',
                size: 'large',
                text: 'continue_with',
                shape: 'pill',
                logo_alignment: 'center',
                locale: 'hu',
                width: 300
            });
        }).catch(function() {
            setHiba(true);
        });
        return function() { megszunt = true; clearTimeout(idozito); };
    }, [clientId]);

    if (!clientId) {
        return null;
    }

    return (
        <div className="googleBelepes">
            <div className="googleGomb" ref={gombRef} />
            {hiba ? <div className="halk">A Google-belépés most nem érhető el. Kérjük, használja az e-mail-címes belépést.</div> : undefined}
        </div>
    );
}
